import { Component } from '@angular/core';

@Component({
    standalone: true,
    template: '<pre>{{ response }}</pre>',
})
export class HealthComponent {
    response = JSON.stringify({ status: 'healthy' });
}
